import { useState, useEffect } from 'react';
import Moment from 'moment';
import toast, { Toaster } from 'react-hot-toast';
import { Row, Col, Card, CardBody, CardHeader, Button, Spinner, Table, Nav, NavItem, NavLink, TabContent, TabPane, Label, Input, Badge, FormGroup } from 'reactstrap';
import axios from 'axios';
import { FaPlus} from 'react-icons/fa';
import uuid from 'react-uuid';
import {Chart as ChartJS,CategoryScale,LinearScale,PointElement,LineElement,Title,Tooltip,Legend} from 'chart.js';
import { Line } from "react-chartjs-2";
import './Ghg.css';
import Action from '../Action/Action';
import { useNavigate, useLocation } from "react-router-dom";
import Documents from '../Uploads/Documents';
import { ToastContainer, toast as toastytoast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { convertToRaw, EditorState, convertFromHTML, ContentState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "draft-js/dist/Draft.css";
import draftToHtml from "draftjs-to-html"; import { apiGet, apiPost } from "../Utilities/Hooks/apiWrapper";

ChartJS.register(CategoryScale,LinearScale,PointElement,LineElement,Title,Tooltip,Legend);

const createGroup = (groupName, options, setGmpValue) => {
    return {
        label: (() => {
            return (
                <div
                    onClick={() =>
                        setGmpValue(value =>
                            value.concat(options.filter(grpOpt => !value.includes(grpOpt)))
                        )
                    }
                >
                    {groupName}
                </div>
            );
        })(),
        options: options
    };
};

const GHGComplete = ({ handleWizardChanged }) => {
    const roleName = localStorage.getItem("roleName"); const [show_SectionComment, setShow_SectionComment] = useState(false);
    const saveRightsForNonItemFieldsAndTables = localStorage.getItem("saveRightsForNonItemFieldsAndTables");
    const { state } = useLocation();
    const navigate = useNavigate();
    const [farmId, setFarmId] = useState(localStorage.getItem("defaultFarmId"));
    const [ghgSection, setGhgSection] = useState({ Section: 'GHG', SectionName: 'GHG', isWizardCompleted: false, sectionObj: {} });
    const [loading, setLoading] = useState(true); const [ghg, setGhg] = useState([]); const [showActionPopup, setShowActionPopup] = useState(false); const [id, setId] = useState(0);
    const [closedActionCount, setClosedActionCount] = useState(0); const [openActionCount, setOpenActionCount] = useState(0); const [isClosedActionShow, setIsClosedActionShow] = useState(false);
    const [activeTab, setActiveTab] = useState('3'); const [seasonList, setSeasonList] = useState([]);
    const [seasonData, setSeasonData] = useState(
        {
            CurrentSeason: {
                methane_Total: "", methane_PerEffHA: "", methane_PerKgProduct: "", nitrousOxide_Total: "", nitrousOxide_PerEffHA: "", nitrousOxide_PerKgProduct: "",
                carbonDioxide_Total: "", carbonDioxide_PerEffHA: "", carbonDioxide_PerKgProduct: "", carbonDioxideFromSequestration_Total: "", carbonDioxideFromSequestration_PerEffHA: "", carbonDioxideFromSequestration_PerKgProduct: "",
                totalGHGEmissions_Total: "", totalGHGEmissions_PerEffHA: "", totalGHGEmissions_PerKgProduct: ""
            },
            CurrentSeasonPlus1: {
                methane_Total: "", methane_PerEffHA: "", methane_PerKgProduct: "", nitrousOxide_Total: "", nitrousOxide_PerEffHA: "", nitrousOxide_PerKgProduct: "",
                carbonDioxide_Total: "", carbonDioxide_PerEffHA: "", carbonDioxide_PerKgProduct: "", carbonDioxideFromSequestration_Total: "", carbonDioxideFromSequestration_PerEffHA: "", carbonDioxideFromSequestration_PerKgProduct: "",
                totalGHGEmissions_Total: "", totalGHGEmissions_PerEffHA: "", totalGHGEmissions_PerKgProduct: "" },
            CurrentSeasonPlus2: {
                methane_Total: "", methane_PerEffHA: "", methane_PerKgProduct: "", nitrousOxide_Total: "", nitrousOxide_PerEffHA: "", nitrousOxide_PerKgProduct: "",
                carbonDioxide_Total: "", carbonDioxide_PerEffHA: "", carbonDioxide_PerKgProduct: "", carbonDioxideFromSequestration_Total: "", carbonDioxideFromSequestration_PerEffHA: "", carbonDioxideFromSequestration_PerKgProduct: "",
                totalGHGEmissions_Total: "", totalGHGEmissions_PerEffHA: "", totalGHGEmissions_PerKgProduct: "" },
            CurrentSeasonMinus1: {
                methane_Total: "", methane_PerEffHA: "", methane_PerKgProduct: "", nitrousOxide_Total: "", nitrousOxide_PerEffHA: "", nitrousOxide_PerKgProduct: "",
                carbonDioxide_Total: "", carbonDioxide_PerEffHA: "", carbonDioxide_PerKgProduct: "", carbonDioxideFromSequestration_Total: "", carbonDioxideFromSequestration_PerEffHA: "", carbonDioxideFromSequestration_PerKgProduct: "",
                totalGHGEmissions_Total: "", totalGHGEmissions_PerEffHA: "", totalGHGEmissions_PerKgProduct: "" },
            CurrentSeasonMinus2: {
                methane_Total: "", methane_PerEffHA: "", methane_PerKgProduct: "", nitrousOxide_Total: "", nitrousOxide_PerEffHA: "", nitrousOxide_PerKgProduct: "",
                carbonDioxide_Total: "", carbonDioxide_PerEffHA: "", carbonDioxide_PerKgProduct: "", carbonDioxideFromSequestration_Total: "", carbonDioxideFromSequestration_PerEffHA: "", carbonDioxideFromSequestration_PerKgProduct: "",
                totalGHGEmissions_Total: "", totalGHGEmissions_PerEffHA: "", totalGHGEmissions_PerKgProduct: "" }
        });
    const [dataNationalCH4, setDataNationalCH4] = useState({
        label: "CH4",
        data: [28100.79, 28224.24, 27735.2, 27853.83, 28756.39, 29044.85, 29307.68, 30057.45, 29441.15, 29507.39, 30318.98, 30672.76, 30450.58, 30859.55, 30875.67, 31101.28, 31286.79, 30480.48, 29360.43, 29521.84, 29552.01, 29962.67, 30662.56, 30827.99, 31137.63, 30662.78, 30311.91, 30306.74, 30508.89, 30617.19],
        lineTension: 0,
        fill: false,
        borderColor: 'red',
        backgroundColor: 'red',
    });
    const [dataNationalTLL, setDataNationalTLL] = useState({
        label: "Total long lived",
        data: [5739.49, 5850.59, 5893.25, 6166.18, 6448.47, 6769.15, 6799.89, 6913.59, 6933.19, 7056.32, 7400.33, 7885.6, 8124.15, 8321.33, 8445.49, 8584.63, 8233.38, 8127.18, 8064.02, 8125.51, 8251.94, 8495.05, 8644.54, 8556.72, 8872.37, 8830.7, 8803.37, 8799.44, 8961.64, 9000.52],
        lineTension: 0,
        fill: false,
        borderColor: 'brown',
        backgroundColor: 'brown',
    });
    const [dataNationalN2O, setDataNationalN2O] = useState({
        label: "N2O",
        data: [5340.23, 5410.05, 5424.79, 5643.73, 5860.38, 6091.22, 6172.83, 6251.18, 6185.29, 6201.29, 6488.98, 6854.56, 6952.24, 7197.88, 7320.24, 7390.25, 7194.71, 7015.66, 7012.85, 7031.9, 7182.11, 7363.56, 7467.59, 7496.47, 7769.68, 7686.2, 7714.57, 7751.58, 7858.6, 7883.65],
        lineTension: 0,
        fill: false,
        borderColor: 'yellow',
        backgroundColor: 'yellow',
    });
    const [dataNationalCO2, setDataNationalCO2] = useState({
        label: "CO2",
        data: [399.26, 440.54, 468.46, 522.45, 588.09, 677.93, 627.06, 662.41, 747.9, 855.03, 911.35, 1031.04, 1171.91, 1123.45, 1125.25, 1194.38, 1038.67, 1111.52, 1051.17, 1093.61, 1069.83, 1131.49, 1176.95, 1060.25, 1102.69, 1144.5, 1088.8, 1047.86, 1103.04, 1116.87],
        lineTension: 0,
        fill: false,
        borderColor: 'orange',
        backgroundColor: 'orange',
    });
    const [chartData, setChartData] = useState({
        labels: [],
        datasets: [dataNationalCH4, dataNationalTLL, dataNationalN2O, dataNationalCO2]
    });
    const [commentonGHGDetails, setCommentonGHGDetails] = useState({ commentonGHG: '' });
    const [savingComments, setSavingComments] = useState(false);
    const chartOptions = {
        responsive: true,
        plugins: {
            datalabels: {
                display: false
            },
            legend: {
                display: true,
                position: 'bottom',
                labels: {
                    boxWidth: 25,
                    fontColor: 'black'
                }
            }
        },
        scaleOverride: true,
        scales: {
            x: {
                title: {
                    display: true,
                    text: 'Year'
                }
            },
            y: {
                title: {
                    display: true,
                    text: 'Value'
                },
                ticks: {
                    stepSize: 2000
                }
            }
        }
    };

    const [editorState, setEditorState] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(''))));
    const [editorStateGreenhouseGasEmissionsProfile, setEditorStateGreenhouseGasEmissionsProfile] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(''))));
    const [editorStateGreenhouseGasSequestration, setEditorStateGreenhouseGasSequestration] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(''))));
    const [editorStateGreenhouseGasEmissionsPlanOnFarm, setEditorStateGreenhouseGasEmissionsPlanOnFarm] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(''))));
    const [editorStateAdverseEventsResponsePlan, setEditorStateAdverseEventsResponsePlan] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(''))));

    const OnPageload = async (e) => {
        try {
            const response = await apiGet(
                '/api/ghg/GetGHGComplete/', {
                params: { farmId: farmId }
            }
            );
            if (response.data.status) {
                setLoading(false);
                setGhg(response.data.content);
                setGhgSection({ ...ghgSection, isWizardCompleted: response.data.content.isFWFPCompleted, sectionObj: response.data.content.section })
                setOpenActionCount(response.data.content.actions.filter(action => action.isCloseout != true).length);
                setClosedActionCount(response.data.content.actions.filter(action => action.isCloseout == true).length);
                setSeasonData({
                    ...seasonData, CurrentSeasonPlus2: response.data.content.ghgSeasonData.filter(x => x.season == response.data.content.seasonList[4])[0],
                    CurrentSeasonPlus1: response.data.content.ghgSeasonData.filter(x => x.season == response.data.content.seasonList[3])[0],
                    CurrentSeason: response.data.content.ghgSeasonData.filter(x => x.season == response.data.content.seasonList[2])[0],
                    CurrentSeasonMinus1: response.data.content.ghgSeasonData.filter(x => x.season == response.data.content.seasonList[1])[0],
                    CurrentSeasonMinus2: response.data.content.ghgSeasonData.filter(x => x.season == response.data.content.seasonList[0])[0]
                });
                setSeasonList(response.data.content.seasonList);
                setChartData({ ...chartData, labels: response.data.content.dataNationalYear });
                setCommentonGHGDetails({ commentonGHG: response.data.content.commentsGHGOverview })
                setShow_SectionComment(response.data.content.show_SectionComment);
                const content = ContentState.createFromBlockArray(convertFromHTML(response.data.content.commentsGHGOverview == null ? '' : response.data.content.commentsGHGOverview))
                setEditorState(EditorState.createWithContent(content));

                const contentGreenhouseGasEmissionsProfile = ContentState.createFromBlockArray(convertFromHTML(response.data.content.ghgHeader.greenhouseGasEmissionsProfile == null ? '' : response.data.content.ghgHeader.greenhouseGasEmissionsProfile))
                setEditorStateGreenhouseGasEmissionsProfile(EditorState.createWithContent(contentGreenhouseGasEmissionsProfile));

                const contentGreenhouseGasSequestration = ContentState.createFromBlockArray(convertFromHTML(response.data.content.ghgHeader.greenhouseGasSequestration == null ? '' : response.data.content.ghgHeader.greenhouseGasSequestration))
                setEditorStateGreenhouseGasSequestration(EditorState.createWithContent(contentGreenhouseGasSequestration));

                const contentGreenhouseGasEmissionsPlanOnFarm = ContentState.createFromBlockArray(convertFromHTML(response.data.content.ghgHeader.greenhouseGasEmissionsPlanOnFarm == null ? '' : response.data.content.ghgHeader.greenhouseGasEmissionsPlanOnFarm))
                setEditorStateGreenhouseGasEmissionsPlanOnFarm(EditorState.createWithContent(contentGreenhouseGasEmissionsPlanOnFarm));

                const contentAdverseEventsResponsePlan = ContentState.createFromBlockArray(convertFromHTML(response.data.content.ghgHeader.adverseEventsResponsePlan == null ? '' : response.data.content.ghgHeader.adverseEventsResponsePlan))
                setEditorStateAdverseEventsResponsePlan(EditorState.createWithContent(contentAdverseEventsResponsePlan));

                const { itemId, actionId, navigateFrom } = state;
                navigate(state.pathname, { replace: true });
                if (navigateFrom == "Actions") {
                    handleNavigateOpenActionPopup(itemId, actionId, response.data.content);
                }
            }

        } catch (err) {
            console.log(err);
        }
    }

    const handleNavigateOpenActionPopup = (itemId, actionId, ghg) => {
        setShowActionPopup(true);
        setId(actionId)
    };

    useEffect(() => {
        setLoading(true);
        OnPageload();
    }, [])

    const handleOpenActionPopup = async (e) => {
        setShowActionPopup(true);
        setId(0)
    };

    const handleOpenAction = async (e, item) => {
        setShowActionPopup(true);
        setId(item.id)
    };

    function handleActionClose() {
        setShowActionPopup(false);
    }

    function handleClosedActionShow(event) {
        setIsClosedActionShow(event.target.checked);
    }

    const handleCommentsSave = async (e) => {
        e.preventDefault()
        setSavingComments(true);

        let form = {
            Id: farmId,
            commentsGHGOverview: commentonGHGDetails.commentonGHG,
        }
        const response = await apiPost(
            '/api/GHG/GHGOverViewSave/', JSON.stringify(form),
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            });
        if (response.data != null) {
            if (response.data.status) {
                toast.success("GHG Overview Comments Saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                setSavingComments(false);
            }
        }
    };

    const CustomToastWithLink = (message) => (
        <div>
            <p>{message}</p>
        </div>
    );
    const customId = "custom-id-yes1";
    const showToastMessage = (e, message) => {
        e.stopPropagation();
        toastytoast.info(CustomToastWithLink(message), {
            autoClose: false, theme: "colored", hideProgressBar: true, icon: false, toastId: customId, rtl: false
        });
    };
    const [userId, setUserId] = useState(localStorage.getItem("loggedInUserId"));
    const [savingSectionComment, setSavingSectionComment] = useState('');
    const saveSectionComment = async () => {
        setSavingSectionComment(true);
        try {
            var form = {
                farmId: farmId,
                comment: draftToHtml(convertToRaw(editorState.getCurrentContent())),
                GreenhouseGasEmissionsProfile: draftToHtml(convertToRaw(editorStateGreenhouseGasEmissionsProfile.getCurrentContent())),
                GreenhouseGasSequestration: draftToHtml(convertToRaw(editorStateGreenhouseGasSequestration.getCurrentContent())),
                GreenhouseGasEmissionsPlanOnFarm: draftToHtml(convertToRaw(editorStateGreenhouseGasEmissionsPlanOnFarm.getCurrentContent())),
                AdverseEventsResponsePlan: draftToHtml(convertToRaw(editorStateAdverseEventsResponsePlan.getCurrentContent())),
                UserId: userId
            };
            const response = await apiPost(
                '/api/ghg/SaveSectionComment/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });
            if (response) {
                setSavingSectionComment(false);
            }
        } catch (err) {
            console.log(err);
            setSavingSectionComment(false);
        }
    }

    return (
        <div>
            <ToastContainer position="top-center" containerStyle={{ top: '50%' }} />
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <Row>
                <Col><h2>{ghgSection.SectionName}</h2></Col>
            </Row>
            {loading ? <Spinner color="success"> Loading... </Spinner> :
                <Row xs="2">
                    <Col>

                        <Card className="my-4">
                            <CardHeader className="d-flex">

                            </CardHeader>
                            <CardBody>
                                <Row style={{ marginTop: "0.5vh" }}>
                                    {show_SectionComment &&
                                        <Col sm="12">
                                            <FormGroup>
                                                <Label for="sectionComment" className="text-capitalize" style={{ fontSize: "14px" }}><b>Comment or background on GHG overview and reasoning on the farm</b></Label>
                                                <Editor handlePastedText={() => false} spellCheck={true}
                                                    defaultEditorState={editorState}
                                                    onEditorStateChange={setEditorState}
                                                    wrapperClassName="wrapper-class"
                                                    editorClassName="editor-class"
                                                    toolbarClassName="toolbar-class"
                                                    toolbar={
                                                        {
                                                            options: ['inline'], inline: {
                                                                inDropdown: false,
                                                                options: ['bold', 'italic', 'underline'],
                                                            }
                                                        }
                                                    }
                                                />
                                            </FormGroup>

                                        </Col>
                                    }
                                    <Row>
                                        <Col sm="6">
                                            <FormGroup>
                                                <Label for="sectionComment" className="text-capitalize" style={{ fontSize: "14px" }}><b>Greenhouse Gas emissions profile</b></Label>
                                                <Editor handlePastedText={() => false} spellCheck={true}
                                                    defaultEditorState={editorStateGreenhouseGasEmissionsProfile}
                                                    onEditorStateChange={setEditorStateGreenhouseGasEmissionsProfile}
                                                    wrapperClassName="wrapper-class"
                                                    editorClassName="editor-class"
                                                    toolbarClassName="toolbar-class"
                                                    toolbar={
                                                        {
                                                            options: ['inline'], inline: {
                                                                inDropdown: false,
                                                                options: ['bold', 'italic', 'underline'],
                                                            }
                                                        }
                                                    }
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col sm="6">
                                            <FormGroup>
                                                <Label for="sectionComment" className="text-capitalize" style={{ fontSize: "14px" }}><b>Greenhouse Gas sequestration</b></Label>
                                                <Editor handlePastedText={() => false} spellCheck={true}
                                                    defaultEditorState={editorStateGreenhouseGasSequestration}
                                                    onEditorStateChange={setEditorStateGreenhouseGasSequestration}
                                                    wrapperClassName="wrapper-class"
                                                    editorClassName="editor-class"
                                                    toolbarClassName="toolbar-class"
                                                    toolbar={
                                                        {
                                                            options: ['inline'], inline: {
                                                                inDropdown: false,
                                                                options: ['bold', 'italic', 'underline'],
                                                            }
                                                        }
                                                    }
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm="6">
                                            <FormGroup>
                                                <Label for="sectionComment" className="text-capitalize" style={{ fontSize: "14px" }}><b>Greenhouse Gas emissions plan on farm</b></Label>
                                                <Editor handlePastedText={() => false} spellCheck={true}
                                                    defaultEditorState={editorStateGreenhouseGasEmissionsPlanOnFarm}
                                                    onEditorStateChange={setEditorStateGreenhouseGasEmissionsPlanOnFarm}
                                                    wrapperClassName="wrapper-class"
                                                    editorClassName="editor-class"
                                                    toolbarClassName="toolbar-class"
                                                    toolbar={
                                                        {
                                                            options: ['inline'], inline: {
                                                                inDropdown: false,
                                                                options: ['bold', 'italic', 'underline'],
                                                            }
                                                        }
                                                    }
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col sm="6">
                                            <FormGroup>
                                                <Label for="sectionComment" className="text-capitalize" style={{ fontSize: "14px" }}><b>Adverse Events Response Plan</b></Label>
                                                <Editor handlePastedText={() => false} spellCheck={true}
                                                    defaultEditorState={editorStateAdverseEventsResponsePlan}
                                                    onEditorStateChange={setEditorStateAdverseEventsResponsePlan}
                                                    wrapperClassName="wrapper-class"
                                                    editorClassName="editor-class"
                                                    toolbarClassName="toolbar-class"
                                                    toolbar={
                                                        {
                                                            options: ['inline'], inline: {
                                                                inDropdown: false,
                                                                options: ['bold', 'italic', 'underline'],
                                                            }
                                                        }
                                                    }
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Col sm="12">
                                        {savingSectionComment ?
                                            <Button style={{ float: "right" }} onClick={saveSectionComment} color="success" disabled>
                                                <Row>
                                                    <Col sm="8">
                                                        <span>
                                                            {' '}Saving
                                                        </span>
                                                    </Col>
                                                    <Col sm="4">
                                                        <Spinner size="sm">
                                                            Saving...
                                                        </Spinner>
                                                    </Col>
                                                </Row>
                                            </Button>
                                            :
                                            <Button style={{ float: "right" }} onClick={saveSectionComment} color="success" size="sm">
                                                Save
                                            </Button>
                                        }
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>

                        <Row>
                            <Col>
                                <Card className="my-4">
                                    <h4 className="card-header d-flex justify-content-between align-items-center">
                                        Actions
                                        {ghg.farmCenter != null &&
                                            <Button style={{ float: "right" }} onClick={handleOpenActionPopup} color="success" size="sm">
                                                <FaPlus /> Action
                                            </Button>
                                        }
                                    </h4>
                                    <CardBody>
                                        <Row>
                                            <Col sm="12">
                                                <table className="table borderless">
                                                    <thead></thead>
                                                    <tbody>
                                                        {closedActionCount > 0 ?
                                                            <tr key={uuid()}>
                                                                <td>

                                                                    <label className="lable-sm-upper float-end">Show Closed Actions ({closedActionCount})</label>
                                                                    <input className="float-end closeCheckbox" type="checkbox" checked={isClosedActionShow} onChange={handleClosedActionShow}></input>

                                                                </td>
                                                            </tr>
                                                            : ''}
                                                        {
                                                            ghg.actions != undefined && ghg.actions.length != 0 ?

                                                                <tr className="actions-table" key={uuid()}>
                                                                    <td >
                                                                        <Table className='table borderless '>
                                                                            <thead >
                                                                                <tr>
                                                                                    <th> # </th>
                                                                                    <th style={{ textAlign: 'center' }}> Category </th>
                                                                                    <th style={{ width: '10%' }}> Due </th>
                                                                                    <th className="text-center"> Opportunity </th>
                                                                                    <th style={{ width: '20%' }}> Title  </th>
                                                                                    <th style={{ width: '30%' }}> Details </th>
                                                                                    <th></th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {
                                                                                    ghg.actions.map(action =>

                                                                                        <tr key={action.id} className={"" + (action.isCloseout === true ? "closedAction" : "openAction") + " " + (!isClosedActionShow && action.isCloseout === true ? "closed-hidden" : "")}>
                                                                                            <td> {action.id} </td>
                                                                                            <th scope="row" style={{ textAlign: 'center' }}>{action.category == null ? "" : <Badge color="danger">{action.category}</Badge>}  </th>
                                                                                            <td> {action.actionType == 46 ? "Ongoing / Management" : Moment(action.dueDate).format('DD/MM/YYYY')} </td>
                                                                                            <td> {action.ghgItemTypeText} </td>
                                                                                            <td> {action.title} </td>
                                                                                            <td> {action.description} </td>
                                                                                            <td>  {action.isCloseout !== true ?
                                                                                                <Button color="warning" size="sm" onClick={(e) => handleOpenAction(e, action)} > Edit </Button> :
                                                                                                <Button color="primary" size="sm" onClick={(e) => handleOpenAction(e, action)} > View </Button>}
                                                                                            </td>
                                                                                        </tr>
                                                                                    )}
                                                                            </tbody>
                                                                        </Table>
                                                                    </td>
                                                                </tr>
                                                                :
                                                                <tr key={uuid()} className="actions-table"><td>No actions for this item...</td></tr>
                                                        }
                                                    </tbody>
                                                </table>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Card className="my-4">
                                    <h4 className="card-header d-flex justify-content-between align-items-center">
                                        National GHG Trends
                                    </h4>
                                    <CardBody>
                                        <Row>
                                            <Col sm="12">
                                                <Line data={chartData} options={chartOptions} />
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Col>
                    <Col>
                        <Row>
                            <Col>
                                <Card className="my-4">
                                    <h4 className="card-header d-flex justify-content-between align-items-center">
                                        Year
                                    </h4>
                                    <CardBody>
                                        {seasonList != undefined && seasonList.length != 0 &&
                                            <div>
                                                <Nav tabs>
                                                    <NavItem>
                                                        <NavLink className={activeTab == '1' ? 'active' : ''} onClick={() => setActiveTab('1')}>
                                                            {seasonList != undefined && seasonList[0]}
                                                        </NavLink>
                                                    </NavItem>
                                                    <NavItem>
                                                        <NavLink className={activeTab == '2' ? 'active' : ''} onClick={() => setActiveTab('2')}>
                                                            {seasonList != undefined && seasonList[1]}
                                                        </NavLink>
                                                    </NavItem>
                                                    <NavItem>
                                                        <NavLink className={activeTab == '3' ? 'active' : ''} onClick={() => setActiveTab('3')}>
                                                            {seasonList != undefined && seasonList[2]}
                                                        </NavLink>
                                                    </NavItem>
                                                    <NavItem>
                                                        <NavLink className={activeTab == '4' ? 'active' : ''} onClick={() => setActiveTab('4')}>
                                                            {seasonList != undefined && seasonList[3]}
                                                        </NavLink>
                                                    </NavItem>
                                                    <NavItem>
                                                        <NavLink className={activeTab == '5' ? 'active' : ''} onClick={() => setActiveTab('5')}>
                                                            {seasonList != undefined && seasonList[4]}
                                                        </NavLink>
                                                    </NavItem>
                                                </Nav>
                                                <TabContent activeTab={activeTab}>
                                                    <br />
                                                    <TabPane tabId="1">
                                                        <table style={{ float: "right", marginTop: "-10px" }} className="table table-bordered table-hover" id="tab_logic">
                                                            <thead>
                                                                <tr>
                                                                    <th className="text-center"> Greenhouse Gas </th>
                                                                    <th className="text-center"> Total </th>
                                                                    <th className="text-center"> Per eff.ha </th>
                                                                    <th className="text-center"> Per kg product </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>Methane(Kg CO2 e)</td>
                                                                    <td>{seasonData.CurrentSeasonMinus2.methane_Total}</td>
                                                                    <td>{seasonData.CurrentSeasonMinus2.methane_PerEffHA}</td>
                                                                    <td>{seasonData.CurrentSeasonMinus2.methane_PerKgProduct}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Nitrous Oxide(Kg CO2 e)</td>
                                                                    <td>{seasonData.CurrentSeasonMinus2.nitrousOxide_Total}</td>
                                                                    <td>{seasonData.CurrentSeasonMinus2.ntrousOxide_PerEffHA}</td>
                                                                    <td>{seasonData.CurrentSeasonMinus2.nitrousOxide_PerKgProduct}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Carbon dioxide(Kg CO2 e)</td>
                                                                    <td>{seasonData.CurrentSeasonMinus2.carbonDioxide_Total}</td>
                                                                    <td>{seasonData.CurrentSeasonMinus2.carbonDioxide_PerEffHA}</td>
                                                                    <td>{seasonData.CurrentSeasonMinus2.carbonDioxide_PerKgProduct}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Carbon dioxide from sequestration(Kg CO2 e)</td>
                                                                    <td>{seasonData.CurrentSeasonMinus2.carbonDioxideFromSequestration_Total}</td>
                                                                    <td>{seasonData.CurrentSeasonMinus2.carbonDioxideFromSequestration_PerEffHA}</td>
                                                                    <td>{seasonData.CurrentSeasonMinus2.carbonDioxideFromSequestration_PerKgProduct}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Total Emissions</td>
                                                                    <td>{seasonData.CurrentSeasonMinus2.totalGHGEmissions_Total}</td>
                                                                    <td>{seasonData.CurrentSeasonMinus2.totalGHGEmissions_PerEffHA}</td>
                                                                    <td>{seasonData.CurrentSeasonMinus2.totalGHGEmissions_PerKgProduct}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </TabPane>
                                                    <TabPane tabId="2">
                                                        <table style={{ float: "right", marginTop: "-10px" }} className="table table-bordered table-hover" id="tab_logic">
                                                            <thead>
                                                                <tr>
                                                                    <th className="text-center"> Greenhouse Gas </th>
                                                                    <th className="text-center"> Total </th>
                                                                    <th className="text-center"> Per eff.ha </th>
                                                                    <th className="text-center"> Per kg product </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>Methane(Kg CO2 e)</td>
                                                                    <td>{seasonData.CurrentSeasonMinus1.methane_Total}</td>
                                                                    <td>{seasonData.CurrentSeasonMinus1.methane_PerEffHA}</td>
                                                                    <td>{seasonData.CurrentSeasonMinus1.methane_PerKgProduct}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Nitrous Oxide(Kg CO2 e)</td>
                                                                    <td>{seasonData.CurrentSeasonMinus1.nitrousOxide_Total}</td>
                                                                    <td>{seasonData.CurrentSeasonMinus1.ntrousOxide_PerEffHA}</td>
                                                                    <td>{seasonData.CurrentSeasonMinus1.nitrousOxide_PerKgProduct}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Carbon dioxide(Kg CO2 e)</td>
                                                                    <td>{seasonData.CurrentSeasonMinus1.carbonDioxide_Total}</td>
                                                                    <td>{seasonData.CurrentSeasonMinus1.carbonDioxide_PerEffHA}</td>
                                                                    <td>{seasonData.CurrentSeasonMinus1.carbonDioxide_PerKgProduct}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Carbon dioxide from sequestration(Kg CO2 e)</td>
                                                                    <td>{seasonData.CurrentSeasonMinus1.carbonDioxideFromSequestration_PerEffHA}</td>
                                                                    <td>{seasonData.CurrentSeasonMinus1.carbonDioxideFromSequestration_PerKgProduct}</td>
                                                                    <td>{seasonData.CurrentSeasonMinus1.carbonDioxideFromSequestration_Total}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Total Emissions</td>
                                                                    <td>{seasonData.CurrentSeasonMinus1.totalGHGEmissions_Total}</td>
                                                                    <td>{seasonData.CurrentSeasonMinus1.totalGHGEmissions_PerEffHA}</td>
                                                                    <td>{seasonData.CurrentSeasonMinus1.totalGHGEmissions_PerKgProduct}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </TabPane>
                                                    <TabPane tabId="3">
                                                        <table style={{ float: "right", marginTop: "-10px" }} className="table table-bordered table-hover" id="tab_logic">
                                                            <thead>
                                                                <tr>
                                                                    <th className="text-center"> Greenhouse Gas </th>
                                                                    <th className="text-center"> Total </th>
                                                                    <th className="text-center"> Per eff.ha </th>
                                                                    <th className="text-center"> Per kg product </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>Methane(Kg CO2 e)</td>
                                                                    <td>{seasonData.CurrentSeason.methane_Total}</td>
                                                                    <td>{seasonData.CurrentSeason.methane_PerEffHA}</td>
                                                                    <td>{seasonData.CurrentSeason.methane_PerKgProduct}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Nitrous Oxide(Kg CO2 e)</td>
                                                                    <td>{seasonData.CurrentSeason.nitrousOxide_Total}</td>
                                                                    <td>{seasonData.CurrentSeason.ntrousOxide_PerEffHA}</td>
                                                                    <td>{seasonData.CurrentSeason.nitrousOxide_PerKgProduct}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Carbon dioxide(Kg CO2 e)</td>
                                                                    <td>{seasonData.CurrentSeason.carbonDioxide_Total}</td>
                                                                    <td>{seasonData.CurrentSeason.carbonDioxide_PerEffHA}</td>
                                                                    <td>{seasonData.CurrentSeason.carbonDioxide_PerKgProduct}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Carbon dioxide from sequestration(Kg CO2 e)</td>
                                                                    <td>{seasonData.CurrentSeason.carbonDioxideFromSequestration_Total}</td>
                                                                    <td>{seasonData.CurrentSeason.carbonDioxideFromSequestration_PerEffHA}</td>
                                                                    <td>{seasonData.CurrentSeason.carbonDioxideFromSequestration_PerKgProduct}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Total Emissions</td>
                                                                    <td>{seasonData.CurrentSeason.totalGHGEmissions_Total}</td>
                                                                    <td>{seasonData.CurrentSeason.totalGHGEmissions_PerEffHA}</td>
                                                                    <td>{seasonData.CurrentSeason.totalGHGEmissions_PerKgProduct}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </TabPane>
                                                    <TabPane tabId="4">
                                                        <table style={{ float: "right", marginTop: "-10px" }} className="table table-bordered table-hover" id="tab_logic">
                                                            <thead>
                                                                <tr>
                                                                    <th className="text-center"> Greenhouse Gas </th>
                                                                    <th className="text-center"> Total </th>
                                                                    <th className="text-center"> Per eff.ha </th>
                                                                    <th className="text-center"> Per kg product </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>Methane(Kg CO2 e)</td>
                                                                    <td>{seasonData.CurrentSeasonPlus1.methane_Total}</td>
                                                                    <td>{seasonData.CurrentSeasonPlus1.methane_PerEffHA}</td>
                                                                    <td>{seasonData.CurrentSeasonPlus1.methane_PerKgProduct}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Nitrous Oxide(Kg CO2 e)</td>
                                                                    <td>{seasonData.CurrentSeasonPlus1.nitrousOxide_Total}</td>
                                                                    <td>{seasonData.CurrentSeasonPlus1.ntrousOxide_PerEffHA}</td>
                                                                    <td>{seasonData.CurrentSeasonPlus1.nitrousOxide_PerKgProduct}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Carbon dioxide(Kg CO2 e)</td>
                                                                    <td>{seasonData.CurrentSeasonPlus1.carbonDioxide_Total}</td>
                                                                    <td>{seasonData.CurrentSeasonPlus1.carbonDioxide_PerEffHA}</td>
                                                                    <td>{seasonData.CurrentSeasonPlus1.carbonDioxide_PerKgProduct}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Carbon dioxide from sequestration(Kg CO2 e)</td>
                                                                    <td>{seasonData.CurrentSeasonPlus1.carbonDioxideFromSequestration_Total}</td>
                                                                    <td>{seasonData.CurrentSeasonPlus1.carbonDioxideFromSequestration_PerEffHA}</td>
                                                                    <td>{seasonData.CurrentSeasonPlus1.carbonDioxideFromSequestration_PerKgProduct}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Total Emissions</td>
                                                                    <td>{seasonData.CurrentSeasonPlus1.totalGHGEmissions_Total}</td>
                                                                    <td>{seasonData.CurrentSeasonPlus1.totalGHGEmissions_PerEffHA}</td>
                                                                    <td>{seasonData.CurrentSeasonPlus1.totalGHGEmissions_PerKgProduct}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </TabPane>
                                                    <TabPane tabId="5">
                                                        <table style={{ float: "right", marginTop: "-10px" }} className="table table-bordered table-hover" id="tab_logic">
                                                            <thead>
                                                                <tr>
                                                                    <th className="text-center"> Greenhouse Gas </th>
                                                                    <th className="text-center"> Total </th>
                                                                    <th className="text-center"> Per eff.ha </th>
                                                                    <th className="text-center"> Per kg product </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>Methane(Kg CO2 e)</td>
                                                                    <td>{seasonData.CurrentSeasonPlus2.methane_Total}</td>
                                                                    <td>{seasonData.CurrentSeasonPlus2.methane_PerEffHA}</td>
                                                                    <td>{seasonData.CurrentSeasonPlus2.methane_PerKgProduct}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Nitrous Oxide(Kg CO2 e)</td>
                                                                    <td>{seasonData.CurrentSeasonPlus2.nitrousOxide_Total}</td>
                                                                    <td>{seasonData.CurrentSeasonPlus2.ntrousOxide_PerEffHA}</td>
                                                                    <td>{seasonData.CurrentSeasonPlus2.nitrousOxide_PerKgProduct}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Carbon dioxide(Kg CO2 e)</td>
                                                                    <td>{seasonData.CurrentSeasonPlus2.carbonDioxide_Total}</td>
                                                                    <td>{seasonData.CurrentSeasonPlus2.carbonDioxide_PerEffHA}</td>
                                                                    <td>{seasonData.CurrentSeasonPlus2.carbonDioxide_PerKgProduct}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Carbon dioxide from sequestration(Kg CO2 e)</td>
                                                                    <td>{seasonData.CurrentSeasonPlus2.carbonDioxideFromSequestration_Total}</td>
                                                                    <td>{seasonData.CurrentSeasonPlus2.carbonDioxideFromSequestration_PerEffHA}</td>
                                                                    <td>{seasonData.CurrentSeasonPlus2.carbonDioxideFromSequestration_PerKgProduct}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Total Emissions</td>
                                                                    <td>{seasonData.CurrentSeasonPlus2.totalGHGEmissions_PerEffHA}</td>
                                                                    <td>{seasonData.CurrentSeasonPlus2.totalGHGEmissions_PerKgProduct}</td>
                                                                    <td>{seasonData.CurrentSeasonPlus2.totalGHGEmissions_Total}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </TabPane>
                                                </TabContent>
                                            </div>

                                        }
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        {/*Document Upload*/}
                        {
                            ghgSection.sectionObj.isDocumentUploadReq && <Documents refid={ghgSection.sectionObj.id} uploadType="Section" open={false} showArrow={true}></Documents>
                        }
                    </Col>
                </Row>
            }
            {showActionPopup && <Action itemList={[]} isGHGNutrient={true} selectedLUId={0} redirectPage="/ghgcomplete" handleActionClose={handleActionClose} itemTypeId={0} sectionName="GHG" sectionId={ghg.itemTypes[0].sectionId} itemId={ghg.farmCenter.itemId} itemName={ghg.farmCenter.name}
                showActionPopupModal={showActionPopup} actionId={id} itemTypeSelect={ghg.itemTypes} itemTypeDisabled={false}></Action>}
        </div>
    )
}
export default GHGComplete;